import { TickIcon } from '@fourthwall/icons'
import React from 'react'

import { isLight } from '../../utils/colors'
import { Icon } from '../Icon'
import * as S from './styled'
import type { ColorItemProps } from './types'

export const ColorItem = ({
  color,
  size = 'medium',
  appearance = 'single-select',
  selected = false,
  hoverable = false,
  onClick,
}: ColorItemProps) => (
  <S.Container data-testid="ColorItem.Container">
    <S.ColorContainer
      title={color.label}
      $appearance={appearance}
      $hoverable={hoverable || !!onClick}
      $selected={selected}
      onClick={onClick ? () => onClick(color) : undefined}
      data-testid="ColorItem.ColorContainer"
    >
      <S.Color $size={size} style={{ background: color.value }} data-testid="ColorItem.Color">
        {appearance === 'multi-select' && selected && (
          <S.CheckMark $light={isLight(color.value)} data-testid="ColorItem.CheckMark">
            <Icon component={TickIcon} height={12} />
          </S.CheckMark>
        )}
      </S.Color>
    </S.ColorContainer>
  </S.Container>
)
